import {Result, Button} from 'antd';
import React from 'react';
import {Link} from 'react-router-dom'; // Optional: if using React Router for navigation

import {allRoutes} from '../../../constants/Routes';

const NotFoundPage: React.FC = () => {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        background: '#ffffff'
      }}
    >
      <Result
        status="500"
        title="404"
        subTitle="This route does not exist."
        style={{margin: 'auto'}}
        extra={
          <Button type="primary">
            <Link to={allRoutes.HOME.HOME}>Back to Home</Link>{' '}
            {/* Replace with your home route or remove Link if not using router */}
          </Button>
        }
      />
    </div>
  );
};

export default NotFoundPage;
